import React, { useState } from 'react';
import Layout from './components/Layout';
import ApplicationForm from './components/ApplicationForm';
import SuccessMessage from './components/SuccessMessage';
import logo from './assets/insurtale-logo.webp';

function App() {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSuccess = () => {
    setIsSubmitted(true);
  };

  return (
    <Layout
      header={
        <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
          <img src={logo} alt="insur_tale logo" style={{ height: 'auto', width: '10rem' }} />
          <h2>Toolbox</h2>
        </div>
      }
    >
      {isSubmitted ? <SuccessMessage /> : <ApplicationForm onSuccess={handleSuccess} />}
    </Layout>
  );
}

export default App;
